import PropTypes from 'prop-types'
import Input from '@/components/Input'
import Button from '@/components/Button'
import FormError from '@/components/FormError'
import { validateEmail } from '@/utils/validate-email'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

const EmailStep = ({ email, onChange, onSubmit, loading, error }) => {
  const { dex } = getEnvAndDex()
  const { dexName } = getDexConfig(dex)

  return (
    <>
      <div className="w-full flex flex-col gap-4">
        <h1 className="m-0 font-avenir-heavy tracking-normal text-grey-10 text-[2.5rem] leading-12 font-heavy max-tablet-p:text-[2rem] max-tablet-p:leading-8 max-tablet-p:text-center">
          Welcome to {dexName} Approval Portal
        </h1>
        <p className="font-avenir-medium type-body-2 tracking-normal text-grey-50 m-0 max-tablet-p:text-center">
          Please enter your email to receive a one-time passcode
        </p>
      </div>
      <div>
        <form onSubmit={onSubmit} noValidate>
          <div className="flex flex-col relative">
            <Input
              name="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={onChange}
              // errorMessage={error}
              disabled={loading}
              disableClear={true}
              inputHeight={true}
            />
            {error && <FormError message={error} />}
          </div>
          <div className="mt-10 max-tablet-p:mt-6 flex justify-start">
            <Button
              type="submit"
              round
              loading={loading}
              disabled={!validateEmail(email)}
              addClass="w-49 max-tablet-p:w-full"
            >
              Send OTP
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

EmailStep.propTypes = {
  email: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
}

export default EmailStep
